import React, {Component} from 'react'
import {ModalHeader, Tooltip} from 'reactstrap'
import PropTypes from "prop-types"
import {deleteSku} from './../../../../services/api/apiSku'
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap'
import {message} from "antd";

class DeleteSku extends Component {
    state = {
        tooltipOpen: false,
        isOpen: false,
        error: '',
        loading: false
    }

    _handleToggleModal = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    _handleToggleTooltip = () => {
        this.setState({
            tooltipOpen: !this.state.tooltipOpen,
        })
    }

    _handleDelete = async () => {
        const {itemId, onRefresh} = this.props

        this.setState({
            loading: true
        })

        try {
            const {data: respons} = await deleteSku(itemId)
            const {success, error} = respons

            if(!success) {
                return this.setState({
                    error: error,
                    loading: false
                })
            }

            this.setState({
                loading: false,
                error: '',
                isOpen: false,
            }, () => {
                onRefresh()
                message.success('Xóa sản phẩm thành công');
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    render() {
        const {tooltipOpen, isOpen, error, loading} = this.state
        const {name, itemId} = this.props

        return (
            <div className="DeleteSku ml-1">
                <span title="Xóa">
                    <i onClick={this._handleToggleModal} className="icon-bin text-danger" id={`TooltipDelete${itemId}`}/>
                    <Tooltip placement="top" isOpen={tooltipOpen} target={`TooltipDelete${itemId}`} toggle={this._handleToggleTooltip}>
                        Xóa Sku
                    </Tooltip>
                    {
                        isOpen && (
                            <Modal isOpen={isOpen} toggle={this._handleToggleModal}>
                                <ModalHeader toggle={this._handleToggleModal}>Xóa sản phẩm</ModalHeader>
                                <ModalBody>
                                    <span>Bạn có chắc chắn muốn xóa sản phẩm <strong>{name}</strong>?</span>
                                    {error && <div className="text-danger mt-3">{error}</div>}
                                </ModalBody>
                                <ModalFooter className="d-flex justify-content-between align-items-center">
                                    <Button color="secondary" disabled={loading} onClick={this._handleToggleModal}>Hủy</Button>
                                    <Button color="primary" disabled={loading} onClick={this._handleDelete}>{loading && <i className='fa fa-spin fa-spinner mr-2'/>} Xóa</Button>
                                </ModalFooter>
                            </Modal>
                        )
                    }
                </span>
            </div>
        )
    }

}

DeleteSku.propTypes = {
    itemId: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onRefresh: PropTypes.func.isRequired
}

export default DeleteSku